import React, { Component } from 'react'

import { Row, Col, FormControl } from 'react-bootstrap';

import featureFlags from '../../utils/featureFlags';
import { BASE_COMMISSION } from '../../constants';

const MAX_COMMISSION = 22.5;
const MIN_COMMISSION = 0;

class NetQuote extends Component {
  constructor(props) {
    super(props)
    this.state = {
      inputValue: props.adjustedCommission ? props.adjustedCommission : props.baseCommission,
      errorMessage: ''
    }
  }

  validationNetQuote = (val) => {
    const value = parseFloat(val).toFixed(2);

    if (val === '') {
      return 'Total commission cannot be blank'
    }
    else if (value > MAX_COMMISSION) {
      return `Maximum total commission is ${MAX_COMMISSION}`
    } else if (value <= 0) {
      return `Minimum total commission is ${MIN_COMMISSION}`
    }
    return false
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter' && !this.state.errorMessage) {
      this.props.handleNetQuote(event.target.value)
    }
  }

  onBlur = (event) => {
    !this.state.errorMessage && this.props.handleNetQuote(event.target.value)
  }

  updateInputValue = (event) => {
    const errorMessage = this.validationNetQuote(event.target.value)
    if (errorMessage) {
      this.setState({
        errorMessage,
        inputValue: event.target.value,
      });
    } else {
      this.setState({
        inputValue: event.target.value,
        errorMessage: ''
      });
    }
  }

  render() {
    const { baseCommission } = this.props
    const { inputValue, errorMessage } = this.state
    return (
      <div className="netquote-container">
        <Row>
          <Col xs={8} md={6} className="netQuote">
            <Row>
              <Col xs={7} ><h4>Net Quote (Adjust Total Commission)</h4></Col>
              <Col xs={5} >
                <FormControl
                  min="0"
                  type="number"
                  step="0.01"
                  pattern="^\d*(\.\d{0,2})?$"
                  placeholder="Adjustable Commission"
                  onBlur={this.onBlur}
                  onKeyPress={this.handleKeyPress}
                  value={inputValue}
                  onChange={this.updateInputValue}
                />
              </Col>
            </Row>
            <br />
            {errorMessage &&
              (<Row>
                <Col xs={5} xsOffset={7}><span className="text-danger">{errorMessage}</span></Col>
              </Row>)
            }
            <Row>
              <Col xs={11} ><h4>Commission Adjust By :</h4></Col>
              <Col xs={1} ><h4 className="pull-right">{parseFloat((inputValue || 0) - BASE_COMMISSION).toFixed(2)}%</h4></Col>
            </Row>
          </Col>
        </Row >
      </div>
    )
  }
}

export default NetQuote

